var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicNode(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49997 2V10.55C5.55997 10.01 4.39997 9.8 3.16997 10.23C1.82997 10.71 0.79997 11.9 0.55997 13.3C0.0999698 16.04 2.41997 18.38 5.14997 17.95C7.10997 17.64 8.49997 15.84 8.49997 13.85V4H10.5C11.6 4 12.5 3.1 12.5 2C12.5 0.9 11.6 0 10.5 0H8.49997C7.39997 0 6.49997 0.9 6.49997 2Z",
    fill: "#8F38EF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNode);
export default __webpack_public_path__ + "static/media/MusicNode.2e704bca495898181b90dddcef1290e6.svg";
export { ForwardRef as ReactComponent };